import { handleActions } from 'redux-actions';

import { Location } from '../../../LocationAutocomplete/types';
import { RecentSearchesAction, SET_RECENT_SEARCHES } from './actions';

export const recentSearchesReducer = handleActions(
	{
		[SET_RECENT_SEARCHES]: (state: Location[], action: RecentSearchesAction) => {
			return action.payload;
		}
	},
	[]
);
